import sanitizeHtml from 'sanitize-html';

const sanitizeOptions = {
  allowedTags: [
    'h3',
    'h4',
    'h5',
    'h6',
    'blockquote',
    'p',
    'a',
    'ul',
    'ol',
    'nl',
    'li',
    'b',
    'i',
    'strong',
    'em',
    'strike',
    'hr',
    'br',
    'div',
    'table',
    'thead',
    'caption',
    'tbody',
    'tr',
    'th',
    'td',
    'iframe',
    'u',
    'span',
  ],
  allowedAttributes: {
    a: ['href', 'name', 'target'],
    img: ['src'],
    iframe: ['width', 'height', 'src', 'frameborder', 'allow'],
    span: ['style'],
    p: ['style'],
  },
  selfClosing: [
    'img',
    'br',
    'hr',
    'area',
    'base',
    'basefont',
    'input',
    'link',
    'meta',
  ],
  allowedSchemes: ['http', 'https', 'mailto'],
  allowedSchemesByTag: {},
  allowedSchemesAppliedToAttributes: ['href', 'src'],
  allowProtocolRelative: true,
  allowedIframeHostnames: [
    'www.youtube.com',
    'player.vimeo.com',
    'fast.wistia.net',
    'embed.ted.com',
    'cdnapisec.kaltura.com',
    'www.kaltura.com',
    'media.hartfordhealthcare.org',
    'play.vidyard.com',
    'players.brightcove.net',
    'www.brainshark.com',
  ],
};

const cleanHtml = html => {
  return sanitizeHtml(html, sanitizeOptions);
};

const renderHTML = html => ({
  __html: cleanHtml(html),
});

const htmlSanitizer = rawHtml => renderHTML(rawHtml);

export default htmlSanitizer;
export { cleanHtml };
